import { OfflineEvent } from './OfflineEvent';
import { EventName } from './EventName';

// From https://developers.facebook.com/docs/marketing-api/offline-conversions/#api-flow
export const sampleOfflineEvents: OfflineEvent[] = [
  {
    match_keys: {
      phone: ['13145551234', '16365551234'],
      email: ['email1@example.com', 'email2@example'],
    },
    currency: 'USD',
    value: 16.5,
    direct_attribution: false,
    event_name: EventName.Purchase,
    event_time: 1456870902,
    contents: [
      { id: 'A', quantity: 1 },
      { id: 'B', quantity: 2 },
      { id: 'C', quantity: 1 },
    ],
    custom_data: {
      event_source: 'in_store',
    },
  },
  {
    match_keys: { lead_id: '12345' },
    direct_attribution: false,
    event_name: EventName.Lead,
    event_time: 1446336000,
    contents: [
      { id: 'D', quantity: 4 },
      { id: 'E', quantity: 5 },
      { id: 'F', quantity: 6 },
    ],
    custom_data: {
      event_source: 'email',
      action_type: 'sent_open_click',
      email_type: 'email_type_code',
      email_provider: 'gmail_yahoo_hotmail',
    },
  },
];

export const completeSampleOfflineEvent: OfflineEvent = {
  match_keys: {
    phone: ['phone1', 'phone2'],
    email: ['email1', 'email2'],
    gen: 'm',
    doby: '1988',
    dobm: '05',
    dobd: '30',
    ln: 'doe',
    fn: 'john',
    fi: 'j',
    ct: 'stlouis',
    st: 'mo',
    zip: '63103',
    country: 'us',
    extern_id: 'foo',
    lead_id: 'bar',
  },
  currency: 'USD',
  value: 16,
  event_name: EventName.Purchase,
  direct_attribution: false,
  event_time: 1456870902,
  content_type: 'product',
  contents: [
    {
      id: 'A',
      quantity: 1,
      price: 10.0,
      brand: 'ACME',
      category: 'Shoes',
    },
  ],
  custom_data: {
    event_source: 'in_store',
  },
  order_id: 'order123',
};
